import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import SwipeableBottomSheet from "react-swipeable-bottom-sheet";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { HalfCircleSpinner } from "react-epic-spinners";

import { base_url } from "../Api/Api";
import { Loader } from "../Global/Loader";

import Snackbar from "@material-ui/core/Snackbar";
import Fade from "@material-ui/core/Fade";
import Grow from "@material-ui/core/Grow";

function CitySnak(props) {
  return <Grow {...props} />;
}

function NameShopSnak(props) {
  return <Grow {...props} />;
}

const Shopinfo = (props) => {
  const [snakCity, setSnakCity] = useState({
    open: false,
    Transition: Fade,
  });
  const [snakProvince, setSnakProvince] = useState({
    open: false,
    Transition: Fade,
  });

  const [province, setProvince] = useState([]); // Province
  const [searchProvince, setSearchProvince] = useState(""); // search input value
  const [provinceSearchResult, setProvinceSearchResult] = useState([]);
  //   const [searchprvnc, setSearchprvnc] = useState([]); // search Province
  const [City, setCity] = useState([]); // City
  const [searchCity, setSearchCity] = useState(""); // search input value
  const [citySearchResult, setCitySearchResult] = useState([]);
  //   const [searchcity, setSearchcity] = useState([]); // search Province
  const [shop, setShop] = useState([]); // shop
  const [searchShop, setSearchShop] = useState(""); // search input value
  const [shopSearchResult, setShopSearchResult] = useState([]);
  const [animation, setAnimation] = useState(false);
  const [activates, setActivates] = useState({
    provinceActvie: false,
    cityActvie: false,
    shopActvie: false,
  });
  const [state, setState] = useState({
    checked: false,
    openSheetProvince: false,
    openSheetCity: false,
    openSheetShop: false,
    selectedProvinceTitle: null,
    selectedProvinceValue: null,
    selectedCityTitle: null,
    selectedCityValue: null,
    selectedShopTitle: null,
    selectedShopValue: null,
    snkProvince: 0,
    snkCity: 0,
    errorValid: false,
    errorCity: false,
    errorShop: false,
  });

  useEffect(() => {
    setActivates({
      ...activates,
      provinceActvie: true,
      cityActvie: true,
      shopActvie: true,
    });
    const infoShop = JSON.parse(localStorage.getItem("shopInfo"));
    if (infoShop !== null) {
      setState({
        ...state,
        selectedProvinceTitle: infoShop.provinceTitle,
        selectedProvinceValue: infoShop.provinceId,
        selectedCityTitle: infoShop.cityTitle,
        selectedCityValue: infoShop.cityId,
        selectedShopTitle: infoShop.shopTitle,
        selectedShopValue: infoShop.shopId,
        checked: infoShop.manager,
      });
    }

    setTimeout(() => {
      setAnimation(true);
    }, 300);

    // set province
    const headers = {
      Authorization: "",
      "content-type": "application/json",
    };
    base_url
      .get("getProvinces",)
      .then((response) => {
        setProvince(response.data.provinces);
        setProvinceSearchResult(response.data.provinces);
        setActivates({
          ...activates,
          provinceActvie: false,
        });
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, []);

  useEffect(() => {
    // set Citys
    const headers = {
      Authorization: "",
      "content-type": "application/json",
    };
    base_url
      .get(`cities/${state.selectedProvinceValue}`,)
      .then((response) => {
        setCity(response.data.cities);
        setCitySearchResult(response.data.cities);
        setActivates({
          ...activates,
          cityActvie: false,
        });
      });
  }, [state.selectedProvinceValue]);

  useEffect(() => {
    // set Citys
    const headers = {
      Authorization: "",
      "content-type": "application/json",
    };
    base_url
      .get(`stores/${state.selectedCityValue}`,)
      .then((response) => {
        setShop(response.data.stores);
        setShopSearchResult(response.data.stores);
        setActivates({
          ...activates,
          shopActvie: false,
        });
      });
  }, [state.selectedCityValue]);

  const handleChangeManeger = (event) => {
    setState({
      ...state,
      checked: event.target.checked,
    });
  };

  const handleCloseCity = () => {
    setSnakCity({
      ...snakCity,
      open: false,
    });
  };

  const handleCloseProvince = () => {
    setSnakProvince({
      ...snakProvince,
      open: false,
    });
  };

  // open bottom sheet
  const handleSheet = (target, id, Transition) => {
    // document.getElementById(id+'-label').classList.add('MuiInputLabel-shrink')
    if (id == "City" && state.selectedProvinceValue == null) {
      setState({
        ...state,
        snkProvince: state.snkProvince + 2,
        errorCity: true,
      });
      setSnakCity({
        open: true,
        Transition,
      });
    } else if (id == "Shop" && state.selectedCityValue == null) {
      setState({
        ...state,
        snkCity: state.snkCity + 2,
        errorShop: true,
      });
      setSnakProvince({
        open: true,
        Transition,
      });
    } else {
      setState({
        ...state,
        [target]: true,
      });
    }
  };

  // close bottom sheet
  const handleBottomSheet = (isOpen, target) => {
    setState({
      ...state,
      [target]: isOpen,
    });
  };

  // set value of
  const handleOption = (e, target) => {
    let title = `selected${target}Title`;
    let value = `selected${target}Value`;
    let bottomSheet = `openSheet${target}`;
    let label = `${target}-label`;
    document.getElementById(label).classList.add("MuiInputLabel-shrink");
    if (target == "Province") {
      setState({
        ...state,
        selectedCityTitle: null,
        selectedCityValue: null,
        selectedShopTitle: null,
        selectedShopValue: null,
        [title]: e.target.labels[0].innerText,
        [value]: e.target.value,
        [bottomSheet]: false,
      });
    } else if (target == "City") {
      setState({
        ...state,
        selectedShopTitle: null,
        selectedShopValue: null,
        [title]: e.target.labels[0].innerText,
        [value]: e.target.value,
        [bottomSheet]: false,
      });
    } else {
      setState({
        ...state,
        [title]: e.target.labels[0].innerText,
        [value]: e.target.value,
        [bottomSheet]: false,
      });
    }
  };

  const contniue = () => {
    const data = {
      provinceTitle: state.selectedProvinceTitle,
      provinceId: state.selectedProvinceValue,
      cityTitle: state.selectedCityTitle,
      cityId: state.selectedCityValue,
      shopTitle: state.selectedShopTitle,
      shopId: state.selectedShopValue,
      manager: state.checked,
    };
    if (
      state.selectedProvinceValue !== null &&
      state.selectedCityValue !== null &&
      state.selectedShopValue !== null
    ) {
      localStorage.setItem("shopInfo", JSON.stringify(data));
      props.history.push("/Entrance/step6");
    } else {
      setState({
        ...state,
        errorValid: true,
      });
    }
  };
  const changeShopsSearch = (e) => {
    setSearchShop(e.target.value);
    search(shop, e.target.value, "name", setShopSearchResult);
  };
  const changeProvinceSearch = (e) => {
    setSearchProvince(e.target.value);
    search(province, e.target.value, "name", setProvinceSearchResult);
  };
  const changeCitySearch = (e) => {
    setSearchCity(e.target.value);
    search(City, e.target.value, "name", setCitySearchResult);
  };
  const containsText = (text, searchText) => text.includes(searchText);
  const search = (data, searchText, searchBy, modifier) => {
    if (searchText) {
      const searchedResult = data.filter((item) =>
        containsText(item[searchBy], searchText)
      );
      modifier(searchedResult);
    } else {
      modifier(data);
    }
  };
  return (
    <div className={`entrnc-base shop-info ${animation ? "active" : ""}`}>
      <Loader active={false} />

      <Snackbar
        open={snakCity.open}
        onClose={handleCloseCity}
        TransitionComponent={snakCity.Transition}
        message="ابتدا استان را انتخاب کنید"
        key={snakCity.Transition.name}
      />
      <Snackbar
        open={snakProvince.open}
        onClose={handleCloseProvince}
        TransitionComponent={snakProvince.Transition}
        message="ابتدا شهر را انتخاب کنید"
        key={snakProvince.Transition.name}
      />

      <div className="titles-base titles-style-2">
        <h4>
          <Link to="/Entrance/step3">
            <i className="icon-arrow-down-sign-to-navigate"></i>
          </Link>
          اطلاعات فروشگاه
        </h4>
        <div className="step-progress">
          <span className="active"></span>
          <span className="active"></span>
          <span></span>
        </div>
      </div>

      <div className="bx-info">
        <div
          className={`input-form ${state.openSheetProvince ? "actived" : ""}`}
          onClick={() => handleSheet("openSheetProvince", "Province")}
        >
          <TextField
            id="Province"
            label="استان *"
            value={state.selectedProvinceTitle}
          />
          <i className="icon-arrow-down-sign-to-navigate"></i>
          <span
            className={`error-respns ${
              state.errorValid && state.selectedProvinceTitle == null
                ? "active"
                : ""
            }`}
          >
            <i className="icon-exclamation-mark"></i>
            استان خود را انتخاب کنید
          </span>
        </div>
        <div
          className={`input-form ${state.openSheetCity ? "actived" : ""}`}
          onClick={() => handleSheet("openSheetCity", "City", CitySnak)}
        >
          <TextField
            id="City"
            label="شهر *"
            value={
              state.selectedCityTitle == null ? "" : state.selectedCityTitle
            }
          />
          <i className="icon-arrow-down-sign-to-navigate"></i>
          <span
            className={`error-respns ${
              state.errorValid && state.selectedCityTitle == null
                ? "active"
                : ""
            }`}
          >
            <i className="icon-exclamation-mark"></i>
            شهر خود را انتخاب کنید
          </span>
        </div>
        <div
          className={`input-form ${state.openSheetShop ? "actived" : ""}`}
          onClick={() => handleSheet("openSheetShop", "Shop", NameShopSnak)}
        >
          <TextField
            id="Shop"
            label="نام فروشگاه *"
            value={
              state.selectedShopTitle == null ? "" : state.selectedShopTitle
            }
          />
          <i className="icon-arrow-down-sign-to-navigate"></i>
          <span
            className={`error-respns ${
              state.errorValid && state.selectedShopTitle == null
                ? "active"
                : ""
            }`}
          >
            <i className="icon-exclamation-mark"></i>
            فروشگاه خود را انتخاب کنید
          </span>
        </div>
        <div className="input-form checkbox">
          <FormControlLabel
            control={
              <Checkbox
                checked={state.checked}
                onChange={handleChangeManeger}
                inputProps={{ "aria-label": "primary checkbox" }}
                color="primary"
              />
            }
            label="مدیر فروشگاه هستم"
          />
        </div>
        <div className="btn-base btn-black btn-sircle">
          <Button variant="contained" onClick={contniue}>
            ادامه
          </Button>
        </div>
        <div className="conrain-sheet">
          <SwipeableBottomSheet
            open={state.openSheetProvince}
            onChange={(e) => handleBottomSheet(e, "openSheetProvince")}
            overflowHeight={0}
          >
            <div style={{ height: "400px" }} className="bottom-sheet">
              <h4>لیست استان ها</h4>
              <div className="search-bx">
                <input
                  type="text"
                  placeholder="جستجو"
                  value={searchProvince}
                  autoFocus
                  onChange={changeProvinceSearch}
                />
                <i className="icon-search"></i>
              </div>
              <div className="body-sheet">
                {state.openSheetProvince ? (
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="gender"
                      name="gender1"
                      value={state.selectedProvinceTitle}
                      onChange={(e) => {
                        handleOption(e, "Province");
                      }}
                    >
                      {provinceSearchResult.length == 0 ? (
                        activates.provinceActvie ? (
                          <div className="loader-item">
                            <HalfCircleSpinner size={40} color="#152b9f" />
                          </div>
                        ) : (
                          <span className="no-info">
                            موردی برای نمایش وجود ندارد
                          </span>
                        )
                      ) : (
                        provinceSearchResult.map((info) => (
                          <div className="radio-btn">
                            <FormControlLabel
                              key={info.id}
                              value={info.id}
                              control={<Radio />}
                              label={info.name}
                            />
                          </div>
                        ))
                      )}
                    </RadioGroup>
                  </FormControl>
                ) : (
                  <div className="loader-item">
                    <HalfCircleSpinner size={40} color="#152b9f" />
                  </div>
                )}
              </div>
            </div>
          </SwipeableBottomSheet>

          <SwipeableBottomSheet
            open={state.openSheetCity}
            onChange={(e) => handleBottomSheet(e, "openSheetCity")}
            overflowHeight={0}
          >
            <div style={{ height: "400px" }} className="bottom-sheet">
              <h4>لیست شهر ها</h4>
              <div className="search-bx">
                <input
                  type="text"
                  placeholder="جستجو"
                  value={searchCity}
                  autoFocus
                  onChange={changeCitySearch}
                />
                <i className="icon-search"></i>
              </div>
              <div className="body-sheet">
                {state.openSheetCity ? (
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="gender"
                      name="gender1"
                      value={state.selectedCityTitle}
                      onChange={(e) => {
                        handleOption(e, "City");
                      }}
                    >
                      {citySearchResult.length == 0 ? (
                        <span className="no-info">
                          موردی برای نمایش وجود ندارد
                        </span>
                      ) : (
                        citySearchResult.map((info, index) => (
                          <div className="radio-btn">
                            <FormControlLabel
                              key={info.id}
                              value={info.id}
                              control={<Radio />}
                              label={info.name}
                            />
                          </div>
                        ))
                      )}
                    </RadioGroup>
                  </FormControl>
                ) : (
                  <div className="loader-item">
                    <HalfCircleSpinner size={40} color="#152b9f" />
                  </div>
                )}
              </div>
            </div>
          </SwipeableBottomSheet>

          <SwipeableBottomSheet
            open={state.openSheetShop}
            onChange={(e) => handleBottomSheet(e, "openSheetShop")}
            overflowHeight={0}
          >
            <div style={{ height: "400px" }} className="bottom-sheet add-shop">
              <div className="row-head">
                <h4>لیست فروشگاه ها</h4>
                <Link to="/Entrance/step5">
                  افزودن فروشگاه<b>+</b>
                </Link>
              </div>
              <div className="search-bx">
                <input
                  type="text"
                  placeholder="جستجو"
                  value={searchShop}
                  autoFocus
                  onChange={changeShopsSearch}
                />
                <i className="icon-search"></i>
              </div>
              <div className="body-sheet">
                {state.openSheetShop ? (
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="gender"
                      name="gender1"
                      value={state.selectedShopTitle}
                      onChange={(e) => {
                        handleOption(e, "Shop");
                      }}
                    >
                      {shopSearchResult.length == 0 ? (
                        <span className="no-info">
                          موردی برای نمایش وجود ندارد
                        </span>
                      ) : (
                        shopSearchResult.map((info, index) => (
                          <div className="radio-btn" key={index}>
                            <FormControlLabel
                              key={info.id}
                              value={info.id}
                              control={<Radio />}
                              label={info.name}
                            />
                            <p>{info.address}</p>
                          </div>
                        ))
                      )}
                    </RadioGroup>
                  </FormControl>
                ) : (
                  <div className="loader-item">
                    <HalfCircleSpinner size={40} color="#152b9f" />
                  </div>
                )}
              </div>
            </div>
          </SwipeableBottomSheet>
        </div>
      </div>
    </div>
  );
};

export default Shopinfo;
